import { BaseEntity, BaseInlineUpdateComponent } from 'yt-ng-framework';

export class OsnovZaPravoNaGo extends BaseEntity {
  constructor() {
      super();
  }
  OsnovZaGoID: number = null;
  PravoNaGoID: number = null;
  BrojDana: number = null;



  Deserialize(input: any) {
      this.ID = input.ID;
      this.OsnovZaGoID = input.OsnovZaGoID;
      this.PravoNaGoID = input.PravoNaGoID;
      this.BrojDana = input.BrojDana;

      return this;
  }

  Serialize(input: OsnovZaPravoNaGo) {
      return input;
  }
}
